import { Tooltip } from '.'
import { isEmpty } from '../../utils/common'
import statusLabelStyles from '../../assets/style/scss/labels.scss'

/**
 * Options for 'type':
 * default, primary, success, info, warning, danger
 **/

export default ({
  text,
  children,
  type = 'default',
  alignment = { marginLeft: '15px' }, // example: { float: 'right', marginRight: '15px' }
  tooltip = {}
}) => {
  const label = <span className={`${statusLabelStyles[`label-${type}`]}`}>{text || children}</span>
  let labelOutput

  if (!isEmpty(tooltip)) {
    labelOutput = (
      <Tooltip
        title={tooltip?.body}
        placement={tooltip?.placement ? tooltip.placement : 'top'}
        container={tooltip?.container ? tooltip.container : 'body'}
        label={tooltip?.label}
      >
        {label}
      </Tooltip>
    )
  } else {
    labelOutput = label
  }

  return <div style={{ display: 'inline-block', ...alignment }}>{labelOutput}</div>
}
